Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "BuyNowButton479012363",
  {"buyNowButton":"BuyNowButton479012363--buyNowButton","root":"BuyNowButton479012363--root","buyNowButtonBackground":"'\"fallback(color(--productPage_buyNowButtonBackgroundColor), color(color-5))\"'","buyNowButtonBorderSize":"'\"fallback(font(--productPage_buyNowButtonBorderSize), 0px)\"'","buyNowButtonBorderColor":"'\"fallback(color(--productPage_buyNowButtonBorderColor), color(color-8))\"'","buyNowButtonBorderRadius":"'\"fallback(font(--productPage_buyNowButtonCornersRadius), unit(0,px))\"'","buyNowButtonTextColor":"'\"fallback(font(--productPage_buyNowButtonTextColor), color(color-8))\"'","buyNowButtonFont":"'\"fallback(font(--productPage_buyNowButtonTextFont), font({theme: 'Body-M', size: '16px'}))\"'"},
  "",
  8,
  "BuyNowButton479012363"
);

